export const CHECK_INS_STATUS_VALUES = {
  PENDING: 'PENDING', // user has not submitted check-in yet
  SUBMITTED: 'SUBMITTED', // user has submitted check-in
  ACKNOWLEDGED: 'ACKNOWLEDGED', // manager has acknowledged check-in
} as const;

export const CHECK_INS_STATUS_LABELS = {
  [CHECK_INS_STATUS_VALUES.PENDING]: 'Incomplete',
  [CHECK_INS_STATUS_VALUES.SUBMITTED]: 'Pending manager review',
  [CHECK_INS_STATUS_VALUES.ACKNOWLEDGED]: 'Reviewed by manager',
} as const;

export const CHECK_INS_STATUS_COLORS = {
  [CHECK_INS_STATUS_VALUES.PENDING]: 'pending',
  [CHECK_INS_STATUS_VALUES.SUBMITTED]: 'submitted',
  [CHECK_INS_STATUS_VALUES.ACKNOWLEDGED]: 'acknowledged',
} as const;

export type CheckInInstance = {
  checkinUpdateInstanceId: number;
  checkinUpdateMasterId: number;
  status: string;
  dueDateTS: number;
  submittedOnTS: number;
  acknowledgedOnTS: number | null;
  questions: CheckInsQuestion[];
};

export type CheckInResponse = {
  providerId: number;
  checkinUpdateText: string;
  checkinUpdateTextHtml: string;
  answerOption: null | string;
};

export type CheckInsQuestion = {
  id: number;
  description: string;
  responses: CheckInResponse[];
};

export type CheckInsHistoryInstance = {
  checkinUpdateInstanceId: number;
  checkinUpdateMasterId: number;
  status: keyof typeof CHECK_INS_STATUS_VALUES;
  dueDateTS: number;
  submittedOnTS: number | null;
  acknowledgedOnTS: number | null;
};

export type CheckInUpdatePayload = {
  instanceId: number;
  questionId: number;
  checkinUpdateText: string;
  checkinUpdateTextHtml: string;
};
